// Client-side CPF helpers — mirror the server's check-digit validation (CpfValidator.cs)
// so the form can reject bad input before a round-trip. The server remains authoritative.

/** Strips non-digits. */
export function cpfDigits(raw: string): string {
  return raw.replace(/\D/g, '')
}

/** Returns true when `raw` is a structurally valid CPF (11 digits + correct check digits). */
export function isValidCpf(raw: string): boolean {
  const digits = cpfDigits(raw)
  if (digits.length !== 11) return false
  if (/^(\d)\1{10}$/.test(digits)) return false // all-same digits

  return checkDigit(digits, 9) === Number(digits[9])
    && checkDigit(digits, 10) === Number(digits[10])
}

function checkDigit(digits: string, length: number): number {
  let sum = 0
  let weight = length + 1
  for (let i = 0; i < length; i++) {
    sum += Number(digits[i]) * weight--
  }
  const remainder = sum % 11
  return remainder < 2 ? 0 : 11 - remainder
}

/** Formats up to 11 digits as `000.000.000-00` progressively (for input masking). */
export function formatCpf(raw: string): string {
  const d = cpfDigits(raw).slice(0, 11)
  return d
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
}
